/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HubTerminalTipOptions } from './HubTerminalTipOptions';
import {
    HubTerminalTipOptionsFromJSON,
    HubTerminalTipOptionsFromJSONTyped,
    HubTerminalTipOptionsToJSON,
    HubTerminalTipOptionsToJSONTyped,
} from './HubTerminalTipOptions';

/**
 * 
 * @export
 * @interface SkipPrompt
 */
export interface SkipPrompt extends HubTerminalTipOptions {
}

/**
 * Check if a given object implements the SkipPrompt interface.
 */
export function instanceOfSkipPrompt(value: object): value is SkipPrompt {
    return true;
}

export function SkipPromptFromJSON(json: any): SkipPrompt {
    return SkipPromptFromJSONTyped(json, false);
}

export function SkipPromptFromJSONTyped(json: any, ignoreDiscriminator: boolean): SkipPrompt {
    return json;
}

export function SkipPromptToJSON(json: any): SkipPrompt {
    return SkipPromptToJSONTyped(json, false);
}

export function SkipPromptToJSONTyped(value?: SkipPrompt | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

